import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import PlantillaFormSections from "./PlantillaFormSections.js";


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileurl: ""
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }


    SetData(data) {
        this.setState({
            fileurl: data.url
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.plantillas.detail}
                postUrl={api.proyectos.config.plantillas.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}

                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"La Plantilla ha sido eliminada con éxito."}
                title={"Eliminar Plantilla"}
                buttonTitle={"Eliminar Plantilla"}
                buttonIcon={"fa fa-trash fa-lg"}

                saveButton={true}
                closeButton={true}
                danger={true}
                saveButtonLabel={"Eliminar"}
                buttonClass={"btn-danger"}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.SetData(data)}>
                <div className="ui-form">
                    <div className="ui-alert ui-alert-danger">
                        <i className="ti ti-trash" aria-hidden="true"></i>
                        Se eliminará la plantilla seleccionada.
                    </div>
                    <PlantillaFormSections
                        disabled={true}
                        fileUrl={this.state.fileurl}
                        showUpload={false} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Proyectos_Plantillas/Delete.js